var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg27001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "173px",
    height: "19px",
    viewBox: "0 0 173 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ISO 27001:2013") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 24,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-1439.000000, -5415.000000)",
    fill: "#C0C0C0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(160.000000, 5337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31-Copy",
    transform: "translate(0.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ISO-27001:2013"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1278,
    y: 27
  }, "ISO 27001:2013"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg27001);
export default __webpack_public_path__ + "static/media/27001.8a9577d34c899aeead9c630a34bfc6f4.svg";
export { ForwardRef as ReactComponent };